import { render, staticRenderFns } from "./TaxesModal.vue?vue&type=template&id=01272ec1&scoped=true&"
import script from "./TaxesModal.vue?vue&type=script&lang=js&"
export * from "./TaxesModal.vue?vue&type=script&lang=js&"
import style0 from "./TaxesModal.vue?vue&type=style&index=0&id=01272ec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01272ec1",
  null
  
)

export default component.exports